import {
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_ERROR,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  UPDATE_NOTIFICATION_READ,
} from './constants';

const initialState = {
  userNotifications: [],
  notificationLoading: false,
  error: null,
};

function notifications(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_NOTIFICATIONS: {
      return {
        ...state,
        notificationLoading: true,
      };
    }

    case GET_ALL_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        userNotifications: payload,
        notificationLoading: false,
      };
    }

    case GET_ALL_NOTIFICATIONS_ERROR: {
      return {
        ...state,
        error: payload,
        notificationLoading: false,
      };
    }

    case UPDATE_NOTIFICATION_READ: {
      return {
        ...state,
        userNotifications: state.userNotifications.map((notif) =>
          notif._id === payload || notif.id === payload
            ? { ...notif, isRead: true, readAt: new Date().toISOString() }
            : notif
        ),
      };
    }

    default:
      return { ...state };
  }
}

export default notifications;
